import TWEEN from '@tweenjs/tween.js';
import * as THREE from 'three';
import { WIDTH, HEIGHT } from '@/constants';

export function popIn(sprite, time = 300) {
	const props = { x: 0.9, y: 0.9 };
	return new TWEEN.Tween(props)
		.to({ x: 1, y: 1 }, time)
		.easing(TWEEN.Easing.Bounce.Out) // Use an easing function to make the animation smooth.
		.onUpdate(() => {
			sprite.scale.x = props.x;
			sprite.scale.y = props.y
		})
		.start()
}

export function shrink(sprite, time = 300) {
	return new Promise((resolve) => {
		const props = { x: 1, y: 1 };
		new TWEEN.Tween(props)
			.to({ x: 0.5, y: 0.5 }, time)
			.easing(TWEEN.Easing.Bounce.InOut) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.scale.x = props.x;
				sprite.scale.y = props.y
			})
			.start()
			.onComplete(() => {
				resolve()
			})
	})
}

export function countdownTween(sprite, time = 1000) {
	return new Promise((resolve) => {
		const props = { x: 1, y: 1 };
		new TWEEN.Tween(props)
			.to({ x: 2, y: 2 }, time)
			.onUpdate(() => {
				sprite.scale.x = props.x;
				sprite.scale.y = props.y
			})
			.start()
			.onComplete(() => {
				resolve()
			})
	})
}

export function bounce(sprite, time = 300) {
	const props = { x: 0.95, y: 0.95 };
	return new Promise((resolve) => {
		return new TWEEN.Tween(props)
			.to({ x: 1.15, y: 1.15 }, time)
			.easing(TWEEN.Easing.Sinusoidal.InOut) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.scale.x = props.x;
				sprite.scale.y = props.y
			})
			.start()
			.onComplete(() => resolve());
	})
}

export function pulse(sprite, time = 300) {
	const props = { color: 0x00FF00, opacity: 0.8 };
	new TWEEN.Tween(props)
		.to({ opacity: 0.3, color: 0xFFC0CB }, time)
		.easing(TWEEN.Easing.Cubic.In) // Use an easing function to make the animation smooth.
		.onUpdate(() => {
			sprite.alpha = props.opacity;
			// sprite.tint = props.color;
		})
		.repeat(Infinity)
		.start();

}

export function crazy(sprite, time = 300) {
	const props = { color: 0x00FF00, opacity: 0.8, angle: sprite.angle, scale: 1 };
	new TWEEN.Tween(props)
		.to({ opacity: 0.3, color: 0xFFC0CB, angle: 35, scale: 3 }, time)
		.easing(TWEEN.Easing.Cubic.In) // Use an easing function to make the animation smooth.
		.onUpdate(() => {
			sprite.alpha = props.opacity;
			sprite.tint = props.color;
			sprite.angle = props.angle;
			sprite.scale.set(props.scale, props.scale)
		})
		.repeat(Infinity)
		.start();

}
export function moveToRainbow(sprite, x, y, time = 1500) {
	return new Promise((resolve) => {
		const props = { x: sprite.x, y: sprite.y, color: 0x00FF00, opacity: 1 };
		const tweenA = new TWEEN.Tween(props)
			.to({ x: x / 2, y: y - 120, opacity: 0.7, color: 0xFFC0CB }, time / 2)
			.easing(TWEEN.Easing.Cubic.In) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.x = props.x;
				sprite.y = props.y;
				sprite.alpha = props.opacity;
				sprite.style = {
					...sprite.style,
					fill: ['#' + Math.floor(props.color).toString(16)]
				}
			});

		const tweenB = new TWEEN.Tween(props)
			.to({ x: x, y: y, opacity: 0.3, color: 0x00FFFF }, time / 2)
			.easing(TWEEN.Easing.Sinusoidal.Out) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.x = props.x;
				sprite.y = props.y;
				sprite.alpha = props.opacity;
				sprite.style = {
					...sprite.style,
					fill: ['#' + Math.floor(props.color).toString(16)]
				}
			});

		tweenA.chain(tweenB, popIn(sprite, time / 2)).start();
		tweenB.onComplete(() => {
			resolve()
		})
	})
}

export function slideDown(sprite, time = 1500) {
	return new Promise((resolve) => {
		const props = { y: sprite.y, opacity: 1 };
		const tweenA = new TWEEN.Tween(props)
			.to({ y: HEIGHT + 100, opacity: 0.7 }, time)
			.easing(TWEEN.Easing.Cubic.In) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.y = props.y;
				sprite.alpha = props.opacity;
			})
			.onComplete(() => resolve()).start();
	});
}

export function shake(sprite, dy = 10, time = 200) {
	return new Promise((resolve, reject) => {
		const props = { x: sprite.x, y: sprite.y - dy };
		new TWEEN.Tween(props)
			.to({ y: sprite.y }, time)
			.easing(TWEEN.Easing.Sinusoidal.InOut) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.y = props.y;
			})
			.onComplete(() => resolve())
			.start();
	})
}

export function melt(sprite, time = 800) {
	return new Promise((resolve, reject) => {
		const props = { opacity: 0 };
		new TWEEN.Tween(props)
			.to({ opacity: 1 }, time)
			.easing(TWEEN.Easing.Sinusoidal.InOut) // Use an easing function to make the animation smooth.
			.onUpdate(() => {
				sprite.alpha = props.opacity;
			})
			.onComplete(() => resolve())
			.start();
	})
}

export function animateMaterialColor(
	material, 
	from = 0xFFFFFF, 
	to = 0xFFD700, 
	time = 200) {
	const props = { color: from };
	new TWEEN.Tween(props)
	.to({ color: to }, time)
	.yoyo(true)
	.onUpdate(() => {
		material.color = new THREE.Color(props.color);
	}).onComplete(()=>{
		material.color = new THREE.Color(from);
	})
	.start();
}

export function animateMeshPosition(
	mesh, 
	to = {dx: 0, dy: 0, dz: 10},
	init = {x: 0, y:0, z: 0},
	time = 200) {
	const props = { ...init};
	new TWEEN.Tween(props)
	.to({ 
		x: props.x + to.dx, 
		y: props.y + to.dy, 
		z: props.z + to.dz }, time)
	.yoyo(true)
	.onUpdate(() => {
		mesh.position.set(props.x, props.y, props.z);
	}).onComplete(()=>{
		mesh.position.set(init.x, init.y, init.z);
	})
	.start();
}

export function smoothScroll(engine, x, time) {
	const props = { x: engine.x };
	const tween = new TWEEN.Tween(props)
		.to({ x }, time)
		.easing(TWEEN.Easing.Linear.None)
		.onUpdate(() => {
			engine.x = props.x;
		}).start();
}

export function sinSwing(sprite, dy, time) {
	const props = { y: sprite.y };
	// to +dy
	const tweenA = new TWEEN.Tween(props)
		.to({ y: sprite.y + dy }, time / 4)
		.easing(TWEEN.Easing.Sinusoidal.InOut)
		.onUpdate(() => {
			sprite.y = props.y;
		});
	// to 0
	const tweenB = new TWEEN.Tween(props)
		.to({ y: sprite.y }, time / 4)
		.easing(TWEEN.Easing.Sinusoidal.In)
		.onUpdate(() => {
			sprite.y = props.y;
		});
	// to -dy
	const tweenC = new TWEEN.Tween(props)
		.to({ y: sprite.y - dy }, time / 4)
		.easing(TWEEN.Easing.Sinusoidal.In)
		.onUpdate(() => {
			sprite.y = props.y;
		});
	tweenA.chain(tweenB).chain(tweenC).chain(tweenB);
	tweenA.start();

}

export function screenSplash(sprite, time = 1000) {
	const props = { y: sprite.y, x: sprite.x, opacity: sprite.alpha, scale: 1 };
	return new Promise((resolve, reject) => {
		new TWEEN.Tween(props)
			.to({ y: -10, opacity: 0, scale: 2, x: sprite.x -= sprite.width }, time)
			.easing(TWEEN.Easing.Sinusoidal.InOut)
			.onUpdate(() => {
				sprite.x = props.x;
				sprite.y = props.y;
				sprite.alpha = props.opacity;
				sprite.scale.set(props.scale, props.scale)
			})
			.onComplete(() => {
				resolve();
			})
			.start();
	})
}